/* CODEX_ACTIVITY_COLLECTION_HALFTONE_V2_20260720 */
(function () {
  function init(root) {
    if (!root || root.dataset.twoNuActivityReady === 'true') return;
    root.dataset.twoNuActivityReady = 'true';
    root.classList.add('is-enhanced');
    root.querySelectorAll('[data-activity-card]').forEach(function (card) {
      var front = card.querySelector('[data-activity-face="front"]');
      var back = card.querySelector('[data-activity-face="back"]');
      if (front) front.setAttribute('aria-hidden', 'false');
      if (back) back.setAttribute('aria-hidden', 'true');
    });
    root.addEventListener('click', function (event) {
      var button = event.target.closest('[data-activity-card-toggle]');
      if (!button || !root.contains(button)) return;
      var card = button.closest('[data-activity-card]');
      if (!card) return;
      var flipped = !card.classList.contains('is-flipped');
      card.classList.toggle('is-flipped', flipped);
      var front = card.querySelector('[data-activity-face="front"]');
      var back = card.querySelector('[data-activity-face="back"]');
      if (front) front.setAttribute('aria-hidden', flipped ? 'true' : 'false');
      if (back) back.setAttribute('aria-hidden', flipped ? 'false' : 'true');
      card.querySelectorAll('[data-activity-card-toggle]').forEach(function (control) {
        control.setAttribute('aria-expanded', flipped ? 'true' : 'false');
      });
      var focusTarget = flipped
        ? back && back.querySelector('[data-activity-card-toggle]')
        : front && front.querySelector('[data-activity-card-toggle]');
      if (focusTarget) window.setTimeout(function () { focusTarget.focus({ preventScroll: true }); }, 260);
    });
  }
  function boot() {
    document.querySelectorAll('[data-two-nu-activity-issues]').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-two-nu-activity-issues]').forEach(init);
  });
})();
